import { ZealApiResponse } from "@zeal/common";
import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import { TUpdateEVerifyPublicCaseStatus } from "./updateEVerifyPublicCaseStatusSchema";

export const updateEVerifyPublicCaseStatus = (axios: IAxiosInstance) => {
  return async (data: TUpdateEVerifyPublicCaseStatus) => {
    const response = await axios.noRetry.post<ZealApiResponse<boolean>>(
      "/api/updateEVerifyPublicCaseStatus",
      { ...data }
    );
    const resData = response.data;
    if (resData.success) {
      return resData.data;
    }
    throw new Error("Something went wrong");
  };
};
